import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API, useAuth } from "../App";
import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import axios from "axios";

const MagicLinkVerify = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [error, setError] = useState("");

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await axios.get(`${API}/onboarding/magic-link/verify?token=${token}`, { withCredentials: true });
        if (res.data.success) {
          setStatus("success");
          await checkAuth();
          setTimeout(() => navigate("/dashboard"), 2000);
        }
      } catch (err) {
        setStatus("error");
        setError(err.response?.data?.detail || "Link non valido o scaduto");
      }
    };
    if (token) verify();
  }, [token, navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-4">
      <div className="max-w-sm w-full text-center space-y-6">
        {status === "verifying" && (
          <>
            <Loader2 className="w-10 h-10 text-emerald-400 animate-spin mx-auto" />
            <h2 className="text-xl font-bold">Verifica in corso...</h2>
            <p className="text-slate-400 text-sm">Stiamo verificando il tuo link di accesso</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto" />
            <h2 className="text-xl font-bold">Accesso effettuato!</h2>
            <p className="text-slate-400 text-sm">Redirect alla dashboard...</p>
          </>
        )}
        {status === "error" && (
          <>
            <AlertTriangle className="w-12 h-12 text-red-400 mx-auto" />
            <h2 className="text-xl font-bold">Link non valido</h2>
            <p className="text-slate-400 text-sm">{error}</p>
            <button
              onClick={() => navigate("/login")}
              className="px-6 py-2.5 rounded-full bg-emerald-500 hover:bg-emerald-400 text-white font-medium text-sm transition-colors"
            >
              Torna al login
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default MagicLinkVerify;
